module.exports = __webpack_public_path__ + "img/360se-4.232b34e0.png";